import { useMemo } from 'react'

import { PdfViewer, Stack, useDialogState, usePdfViewer } from '@collaborate-health/uikit'

import CertificatesImageViewer from '../CertificatesImageViewer'
import CertificateThumbnail from '../CertificateThumbnail'

export interface CertificatePreviewProps {
  src: string
}

const CertificatePreview: React.FC<CertificatePreviewProps> = ({ src }) => {
  const [imageViewerOpen, onOpenImageViewer, onCloseImageViewer] = useDialogState()

  const pdfViewerProps = usePdfViewer()

  const type = useMemo<'image' | 'pdf' | undefined>(() => {
    try {
      const url = new URL(src)
      if (url.pathname.toLowerCase().endsWith('.pdf')) {
        return 'pdf'
      }
    } catch {
      if (src.startsWith('data:application/pdf')) {
        return 'pdf'
      }
    }

    return 'image'
  }, [src])

  const isPdf = type === 'pdf'

  return (
    <Stack overflow='hidden' maxHeight='100%' flexGrow={isPdf ? 1 : undefined} height={isPdf ? '100%' : undefined}>
      {type === 'pdf' && (
        <PdfViewer src={src} variant='rounded' border onClick={onOpenImageViewer} {...pdfViewerProps} />
      )}

      {type === 'image' && <CertificateThumbnail src={src} onClick={onOpenImageViewer} />}

      <CertificatesImageViewer open={imageViewerOpen} src={src} onClose={onCloseImageViewer} />
    </Stack>
  )
}

export default CertificatePreview

